// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

const Badge = styled(BodyCopy)`
  box-sizing: border-box;
  width: fit-content;
  max-width: 100%;
  font-style: normal;
  font-weight: 800;
  font-size: 8px;
  line-height: 11px;
  text-transform: uppercase;
  padding: 2px 6px 1px;
  color: ${(props) => props.theme.colorPalette.blue[700]};
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colorPalette.blue[700]};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  @media ${(props) => props.theme.mediaQuery.medium} {
    font-size: 10px;
    line-height: 14px;
  }
`;

export default Badge;
